import { Controller } from "@hotwired/stimulus"
export default class extends Controller {

    connect() {
        // Devices : touch device or small device => no halo effect
        this.touchDevice = "ontouchstart" in document.documentElement;
        if (window.matchMedia("(max-width:999px)").matches || this.touchDevice) {
            // Add attribute on body to apply other styles
            document.body.setAttribute('data-touch-mobile', 'true');
            return;
        }

        this.onMoveHalo = this.moveHalo.bind(this);
        window.addEventListener("mousemove", this.onMoveHalo, { passive: true });
    }

    disconnect() {
        window.removeEventListener("mousemove", this.onMoveHalo);
    }
    moveHalo(event) {
        this.element.style.left = event.clientX+"px";
        this.element.style.top = event.clientY+"px";

        const bgParent = event.target.closest("[data-bg]");
        const bgValue = bgParent ? bgParent.dataset.bg : "dark";

        if (bgValue) {
            this.element.dataset.onbg = bgValue;
        }
    }
}